<!-- Loading Container -->
@if (isLoading) {
<div class="login-loading" animate.enter="fade-in-animation" animate.leave="fade-out-animation">
  <div class="login-loading-inner-container">
    <img src="{{ customLoader ? customLoader :  'assets/loading.gif' }}" />
    <div>Loading Application</div>
  </div>
</div>
} @else {
<!-- Once Loaded -->
<div class="login-wrapper" animate.enter="fade-in-animation">
  <div class="login-elements">
    <!-- Image and Logos Start -->
    @if (!hasSubdomain || (!clientLogoRect && !clientLogoSquare)) {
      <div class="d-flex align-items-center">
        <img src="assets/icon.png" class="ic-64" alt="Prismforce Logo" />
        <span class="fs-32 ml-2 fw-500 black-text">Prismforce</span>
      </div>
    }
    @if (hasSubdomain &&  (clientLogoRect  || clientLogoSquare)) {
      <img src="{{clientLogoRect||clientLogoSquare}}"
        class="login-elements-logo" alt="Client Logo" />
    }
    <!-- Image and Logos End -->

    <!-- Login Form (only when user is not already logged in) -->
    @if (isUserAuthorised && !user()) {
      <form [formGroup]="loginForm" (ngSubmit)="onLoginClick()" class="w-100 d-flex justify-content-center">
        <div class="login-elements-form">
          @if (state === 'login') {
            <h3 class="login-elements-form-header">Sign in to your account</h3>
          } @else {
            <h3 class="login-elements-form-header mb-0">Reset your password</h3>
            @if (state === 'forgotPassword') {
              <label class="body gray fw-500">
                Having trouble logging in? Enter your email below and we’ll send you instructions for resetting your password.
              </label>
            }
          }
          @if (state!='resetPassword'&&ssoType!='Google Identity'&&ssoType!='Microsoft Identity') {
            <div
              class="login-elements-form-field">
              <label>Email</label>
              <input type="email" placeholder="Enter your email" formControlName="email" required
                autocomplete="off" class="mp-mask">
              @if (loginForm.get('email').touched && loginForm.get('email').invalid) {
                <span class="login-elements-form-field-error">Please enter a
                valid email address</span>
              }
            </div>
          }
          @if (state === 'resetPassword' && resetMode === 'otp') {
            <div class="login-elements-form-field">
              <label>One Time Password</label>
              <input placeholder="Enter the OTP sent to your email address" formControlName="otp" required
                autocomplete="off">
              @if (loginForm.get('otp').touched && loginForm.get('otp').invalid) {
                <span class="login-elements-form-field-error">Please enter the
                correct OTP</span>
              }
            </div>
          }
          @if (state === 'resetPassword' && resetMode === 'defaultPassword') {
            <div class="login-elements-form-field"
              >
              <label>Old Password</label>
              <input type="password" placeholder="Please enter your temporary password"
                formControlName="oldPassword" required autocomplete="off" class="mp-mask">
              @if (loginForm.get('oldPassword').touched && loginForm.get('oldPassword').invalid) {
                <span class="login-elements-form-field-error">
                  {{ loginForm.get('oldPassword').errors && loginForm.get('oldPassword').errors.error ?
                  loginForm.get('oldPassword').errors.error : 'Invalid Password' }}
                </span>
              }
            </div>
          }
          @if (state !== 'forgotPassword' && useSSO === 'No' && forceSSO === 'No') {
            <div class="login-elements-form-field"
              >
              <label>{{ state === 'login' ? 'Password' : 'New Password' }}</label>
              <input type="password" placeholder="Please enter your password" formControlName="password" required
                autocomplete="off" class="mp-mask">
              @if (loginForm.get('password').touched && loginForm.get('password').invalid) {
                <span class="login-elements-form-field-error">
                  {{ loginForm.get('password').errors && loginForm.get('password').errors.error ?
                  loginForm.get('password').errors.error : 'Password is mandatory' }}
                </span>
              }
            </div>
          }
          @if (state === 'resetPassword') {
            <div class="login-elements-form-field">
              <label>Confirm New Password</label>
              <input type="password" placeholder="Please repeat your new password" formControlName="password2"
                required autocomplete="off" class="mp-mask">
              @if (loginForm.get('password2').touched && loginForm.get('password2').invalid) {
                <span class="login-elements-form-field-error">
                  {{ loginForm.get('password2').errors && loginForm.get('password2').errors.error ?
                  loginForm.get('password2').errors.error : 'Passwords must match' }}
                </span>
              }
            </div>
          }
          <div class="login-elements-form-options">
            @if (forceSSO === 'No' && state ==='login' && loginType !== 'Prismforce Password Only' && (ssoType=='ADFS'||ssoType=='LDAP')) {
              <label class="material-checkbox"
                >
                <input type="checkbox" formControlName="sso" (change)="onSSOChange($event)"
                  class="mr-2 t-n1px mt-n1 align-self-start" />
                <span class="mat-checkbox-label caption black">Single sign-on</span>
              </label>
            }
            @if (useSSO === 'No' && forceSSO === 'No') {
              <button type="button"
                class="login-elements-form-options-btn align-self-start" (click)="onForgotClick()">
                {{ state=='login' ? "Forgot Password?" : "" }}
              </button>
            }
            @if (ssoType === 'Google Identity') {
              <div class="align-self-center">
                <div id="g_id_onload" [attr.data-client_id]="oauthClientId" [attr.nonce]="cspNonce" data-auto_prompt="false"></div>
                <div #google class="g_id_signin"></div>
              </div>
            }
            @if (ssoType=='Microsoft Identity') {
              <button class="ms-sign-in-btn align-self-center" (click)="initMicrosoftIdentity()"
                >
                <img class="ms-sign-in" src="assets/ms-sign-in.svg" alt="Microsoft Sign-In" />
              </button>
            }
          </div>
          @if (isCaptchaEnabled ==='Yes' && state !== 'forgotPassword'&& useSSO === 'No'&& forceSSO=='No') {
            <div>
              <div>
                <re-captcha (resolved)="resolved($event)" [siteKey]="siteKey"></re-captcha>
              </div>
              @if (!captcha && showCaptchaError) {
                <span class="login-elements-form-field-error">This field is
                required</span>
              }
            </div>
          }
          @if (ssoType !== 'Google Identity' && ssoType !== 'Microsoft Identity') {
            <button
              type="submit"
              class="login-elements-form-submit-button">
              {{ state === 'login' ? 'Sign In' : state === 'forgotPassword' ? 'Reset Password' : 'Save Password' }}
            </button>
          }
          @if (state === 'forgotPassword') {
            <div class="body gray fw-500">
              <label>Remembered your password?</label>
              <button class="login-elements-form-options-btn"(click)="onForgotClick()">Sign in</button>
            </div>
          }
          @if (state === 'login' && useSSO === 'No' && forceSSO === 'No') {
            <button type="button"
              class="login-elements-form-options-btn"
              (click)="onForgotClick()">
              First time here?
            </button>
          }
        </div>
      </form>
    }
    @if (!isUserAuthorised) {
      <div class="mt-4 fw-500">
        You don't have access to the platform. Please contact the support team/admin team.
      </div>
    }
    @if (!user()) {
      <p class="login-legal caption gray my-16px">
        By signing in, you agree to our
        <a class="color-primary fw-500 text-underline" [href]="termsOfUseUrl" target="_blank" rel="noopener noreferrer">Terms of Use</a>
        and acknowledge the
        <a class="color-primary fw-500 text-underline" [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
      </p>
    }
    @if (hasSubdomain) {
      <div class="d-flex align-items-center login-prismforce-branding">
        <img src="assets/icon.png" class="ic-64" alt="Prismforce Logo" />
        <span class="fs-32 ml-2 fw-500 black-text">Prismforce</span>
      </div>
    }
  </div>
</div>
}
